import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { VesignDataService } from 'src/app/service/vesign-data.service';
import { environment } from 'src/environments/environment';
import { ConsltantPayDetails, WorkorderFormsModel, workorderForms } from 'src/app/Model/WorkorderFormsModel';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-workorder-special',
  templateUrl: './workorder-special.component.html',
  styleUrls: ['./workorder-special.component.css']
})
export class WorkorderSpecialComponent implements OnInit {

  @Input() item = '';
  @Input() expectedProp: { taskId: string, docID: string, docStatus: string, Consultant_Reject: number };
  @Output() parentFun = new EventEmitter<number>();
  lstWorkorderFormsDetails: WorkorderFormsModel[] = [];
  wofsetup: WorkorderFormsModel;
  WorkorderFormsDetails = {};
  ConsultantDetails = {};
  taskId: number = 0;
  Doc_Id: number = 0;
  docStatus: boolean = true;
  CPNY: string = '';
  dept: string = '';
  clientName: string = '';
  Recruiting_Direct: string = '';

  Subtier_ST2_Effective_Date: string = '';
  Subtier_ST2: string = '';

  workorderForms: workorderForms;
  consltantPayDetails: ConsltantPayDetails = { Doc_Id: 0, Task_Id: 0, Emp_Type: '', Pay_Rate: '', Pay_Unit: '', ForWhichWorkOrder: '' };
  WorkDesc: string = '';
  UniqueTerms: string = '';
  test: [] = [];
  txtPayrate: string;
  IsPayRateValid: boolean = false;
  isChecked: boolean = false;
  Size: number = 0;
  isCheckedHour: boolean = false;
  isCheckedAnnum: boolean = false;
  IsTxtPayRate: boolean = false;
  RejectPopupclass: string = "";
  IsRejectPopupOpen: boolean = false;
  RejectionNotes: string = "";
  RejectionNotesError: boolean = false;
  IsConsultant_Reject: boolean = false;
  SelectedParams = {
    Doc_Id: 0,
    RejectionNotes: '',
    taskId: 0
  };
  hourlyrate: any;
  salaryrate: any;
  IsRejectBrnDisabled: boolean = false;
  txtCandidateName: string = "";
  txtContractorName: String = "";
  txtNameOfClient: String = "";
  txtProjectLocation: String = "";
  txtStartDate: String = "";
  txtEndDate: String = "";
  txtWagePayRateNote: String = "";
  txtCRIMINAL_BACKGROUND_CHECK: String = "";
  txtWAGE_RATE_PAID_TO_CONSULTANT_BY_CONTRACTOR: String = "";
  txtCONSULTANT_TYPE: String = "";
  txtPAY_RATE_AND_FEES: String = "";
  txtEndDateNote: String = "";
  isCandidateNameChecked: boolean = false;
  isContractorNameChecked: boolean = false;
  isNameOfClientChecked: boolean = false;
  isProjectLocationChecked: boolean = false;
  isStartDateChecked: boolean = false;
  isEndDateChecked: boolean = false;
  isWork_decsChecked: boolean = false;
  isDESIGNATION_OF_PASSTHROUGHChecked: boolean = false;
  isPAY_RATE_AND_FEES_Checked: boolean = false;
  isCONSULTANT_TYPEChecked: boolean = false;
  isWAGE_RATE_PAID_TO_CONSULTANT_BY_CONTRACTORChecked: boolean = false;
  isCRIMINAL_BACKGROUND_CHECKChecked: boolean = false;
  isUNIQUE_TERMS_AND_CONDITIONSChecked: boolean = false;
  constructor(private dataService: VesignDataService<any>, private route: ActivatedRoute, private spinner: NgxSpinnerService, private toastr: ToastrService, private activeroute: ActivatedRoute) {
    // this.route.queryParams.subscribe(params => {
    //   this.taskId =parseInt(this.expectedProp.taskId);
    // });

    this.wofsetup = {} as WorkorderFormsModel;
    this.workorderForms = {} as workorderForms;
    //this.taskId =  this.activeroute.snapshot.queryParams["TaskId"];
  }
  ngOnInit(): void {
    debugger
    this.taskId = parseInt(this.expectedProp.taskId);
    this.Doc_Id = parseInt(this.expectedProp.docID);
    this.IsConsultant_Reject = this.expectedProp.Consultant_Reject == 1 ? true : false;
    if (this.expectedProp.docStatus == 'Pending') {
      this.docStatus = true;
      this.IsPayRateValid = false;
    } else {
      this.docStatus = false;
      this.IsConsultant_Reject = false;
      this.IsTxtPayRate = false;
      this.GetConslRate();
    }
    this.GetWorkOrderFormsDetails(this.expectedProp.docStatus);
    this.CoompayCall();
    this.GetTempWorkOrder();
    // console.log(1);
  }
  currencyCheck(event): boolean {
    debugger
    let pattern = /^\d+\.?\d{0,2}$/;
    let result = pattern.test(event.key);
    if (this.txtPayrate == null)
      return result;
    else
      return pattern.test(this.txtPayrate.toString() + event.key);
  }
  checkValue(event: any) {
    debugger
    //console.log(event);
    if (event == "A") {
      this.IsRejectBrnDisabled = true;
    }
    else {
      this.IsRejectBrnDisabled = false;
    }
  }
  onFocusOutEvent(event: any) {
    // console.log(event.target.value);
    if (event.target.value < (this.Size == 3 ? 500.01 : 999999.01)) {
      // this.IsPayRateValid=true;
      return false;
    } else {
      // this.IsPayRateValid=false;
      this.toastr.error('Pay rate value will not be more than  ' + (this.Size == 3 ? 500 : 999999));
    }
  }
  GetConslRate() {
    this.dataService.Get(environment.eSignApiUrl + "/api/TakeAction/GetConslRate?Doc_Id=" + this.Doc_Id, null)
      .subscribe((res) => {
        // console.log(res)
        this.consltantPayDetails.Pay_Unit = res.pay_Unit;
        this.txtPayrate = res.pay_Rate;
        if (res.pay_Unit == 'Per Annum') {
          this.isCheckedAnnum = true;
        } else {
          this.isCheckedHour = true;
        }
      });
  }
  GetWorkOrderFormsDetails(value: string = '') {
    this.spinner.show();
    this.dataService.Get(environment.eSignApiUrl + "/api/TakeAction/GetWorkorderFormsDetails?TaskID=" + this.taskId, null)
      .subscribe(
        (response: WorkorderFormsModel) => {
          // console.log(response)
          this.wofsetup = response;
          //console.log(this.wofsetup.candidate_FName)  
          this.dept = this.wofsetup.Dept;
          //console.log(response.hR_ClientInfo_Name)
          this.clientName = this.wofsetup.hR_ClientInfo_Name;
          this.Recruiting_Direct = this.wofsetup.hR_Recruiting_Direct;
          this.Subtier_ST2_Effective_Date = this.wofsetup.hR_Subtier_ST2_Effective_Date;
          this.Subtier_ST2 = this.wofsetup.hR_Subtier_ST2;
          if (value == 'Pending' || value == 'Rejected') {
            this.consltantPayDetails.Pay_Unit = this.wofsetup.payRate_To_Consultant_Units;
            this.txtPayrate = this.wofsetup.payRate_To_Consultant;
            if (this.wofsetup.payRate_To_Consultant_Units.includes('Per Annum')) {
              this.isCheckedAnnum = true;
              this.IsTxtPayRate = true;
              this.salaryrate = this.wofsetup.payRate_To_Consultant;
              this.Size = 5;
              this.consltantPayDetails.Emp_Type = "Salaried Employee"
            }
            if (this.wofsetup.payRate_To_Consultant_Units.includes('Per Hour')) {
              this.isCheckedHour = true;
              this.IsTxtPayRate = true;
              this.hourlyrate = this.wofsetup.payRate_To_Consultant;
              this.Size = 3;
              this.consltantPayDetails.Emp_Type = "Hourly Employee"
            }
            if(value == 'Rejected'){this.IsTxtPayRate = false;}
          }
          //console.log(this.Subtier_ST2_Effective_Date)
          //console.log(this.Subtier_ST2)
          this.spinner.hide();
        },
        error => {
          console.log(error);
        });
  }
  changeStatus(e) {
    debugger
    if (e.target.value == "Hourly Employee") {
      this.consltantPayDetails.Emp_Type = "Hourly Employee"
      this.consltantPayDetails.Pay_Unit = 'Per Hour';
      this.Size = 3;
      this.txtPayrate = '';
      this.txtPayrate = this.hourlyrate;
      this.docStatus = true;
      this.IsTxtPayRate = true;
    }
    else {
      this.consltantPayDetails.Emp_Type = "Salaried Employee";
      this.consltantPayDetails.Pay_Unit = 'Per Annum';
      this.Size = 5;
      this.txtPayrate = '';
      this.txtPayrate = this.salaryrate;
      this.docStatus = true;
      this.IsTxtPayRate = true;
    }
    //console.log(e.target.value);

  }
  GetTempWorkOrder() {
    debugger;
    //GetTempWorkorderFormsDetails
    this.UniqueTerms = "";
    this.WorkDesc = "";
    this.dataService.Get(environment.eSignApiUrl + "/api/TakeAction/GetWorkOrderDynamicClause?TaskID=" + this.taskId + '&DocId=' + this.Doc_Id, null)
      .subscribe((data) => {
        if (data != null) {
          this.UniqueTerms = data.uniqueTerms;
          this.WorkDesc = data.workDesc;
          this.txtCRIMINAL_BACKGROUND_CHECK = data.txtCRIMINAL_BACKGROUND_CHECK;
          this.txtWAGE_RATE_PAID_TO_CONSULTANT_BY_CONTRACTOR = data.txtWAGE_RATE_PAID_TO_CONSULTANT_BY_CONTRACTOR;
          this.txtCONSULTANT_TYPE = data.txtCONSULTANT_TYPE;
          this.txtPAY_RATE_AND_FEES = data.txtPAY_RATE_AND_FEES.toString();
          this.txtEndDateNote = data.txtEndDateNote;
          this.txtWagePayRateNote = data.txtWagePayRateNote;
          this.isCandidateNameChecked = data.isCandidateNameChecked;
          this.isContractorNameChecked = data.isContractorNameChecked;
          this.isNameOfClientChecked = data.isNameOfClientChecked;
          this.isWork_decsChecked = data.isWork_decsChecked;
          this.isProjectLocationChecked = data.isProjectLocationChecked;
          this.isDESIGNATION_OF_PASSTHROUGHChecked = data.isDESIGNATION_OF_PASSTHROUGHChecked;
          this.isStartDateChecked = data.isStartDateChecked;
          this.isEndDateChecked = data.isEndDateChecked;
          this.isPAY_RATE_AND_FEES_Checked = data.isPAY_RATE_AND_FEES_Checked;
          this.isCONSULTANT_TYPEChecked = data.isCONSULTANT_TYPEChecked;
          this.isCRIMINAL_BACKGROUND_CHECKChecked = data.isCRIMINAL_BACKGROUND_CHECKChecked;
          this.isWAGE_RATE_PAID_TO_CONSULTANT_BY_CONTRACTORChecked = data.isWAGE_RATE_PAID_TO_CONSULTANT_BY_CONTRACTORChecked;
          this.isUNIQUE_TERMS_AND_CONDITIONSChecked = data.isUNIQUE_TERMS_AND_CONDITIONSChecked;
          this.txtCandidateName = data.txtCandidateName != null ? data.txtCandidateName : this.wofsetup.candidate_FName + ' ' + this.wofsetup.candidate_LName;
          this.txtContractorName = data.txtContractorName != null ? data.txtContractorName : this.wofsetup.subtier_Company;
          this.txtNameOfClient = data.txtNameOfClient != null ? data.txtNameOfClient : this.wofsetup.hR_ClientInfo_Name;
          this.txtProjectLocation = data.txtProjectLocation != null ? data.txtProjectLocation : this.wofsetup.hR_Project_Location_City + ', ' + this.wofsetup.hR_Project_Location_State;
          this.txtStartDate = data.txtStartDate != null ? data.txtStartDate : this.wofsetup.hR_Project_StartDate;
          this.txtEndDate = data.txtEndDate != null ? data.txtEndDate : this.wofsetup.hR_Project_EndDate;
        }
      });
  }
  CoompayCall() {
    if (this.dept == 'cx') {
      this.CPNY = "Cognixia";
    }
    else {
      this.CPNY = "Ascendion";
    }
  }
  IsValidation: boolean = false;
  CheckValidation() {
    this.IsValidation = false;
    if (this.isWAGE_RATE_PAID_TO_CONSULTANT_BY_CONTRACTORChecked) {
      if (this.txtPayrate == '' || this.txtPayrate == undefined) {
        this.toastr.error('Please mention the wage rate paid to the consultant');
        this.IsValidation = true;
      }
      else if (!this.isChecked) {
        this.toastr.error("Please select 'I agree that all details are correct");
        this.IsValidation = true;
      }
      else if (parseFloat(this.txtPayrate) > (this.Size == 3 ? 500.01 : 999999.01)) {
        this.toastr.error('Pay rate value will not be more than ' + (this.Size == 3 ? 500 : 999999));
        this.IsValidation = true;
      }
    }
    else {
      if (!this.isChecked) {
        this.toastr.error("Please select 'I agree that all details are correct");
        this.IsValidation = true;
      }
    }
  }
  SaveWorkorder() {
    debugger
    this.CheckValidation();
    if (!this.IsValidation) {
      this.spinner.show();
      this.consltantPayDetails.Pay_Rate = this.txtPayrate;
      this.consltantPayDetails.Doc_Id = this.Doc_Id;
      this.consltantPayDetails.Task_Id = this.taskId;
      this.consltantPayDetails.ForWhichWorkOrder = 'WOSP';
      this.dataService.Post(environment.eSignApiUrl + "/api/TakeAction/VendorSaveConslRateInWorkorderForms", this.consltantPayDetails)
        .subscribe(res => {
          this.spinner.hide();
          setTimeout(() => {
            this.toastr.success("Document Updated successfully.");
            this.parentFun.emit(this.Doc_Id);// Doc_Id for workorder reviewed
          }, 4000)
        }
        );
    }
  }

  RejectWorkorder() {
    debugger
    if (this.RejectionNotes == '') {
      this.RejectionNotesError = true;
      return true;
    }
    else {
      this.RejectionNotesError = false;
    }

    this.SelectedParams.Doc_Id = this.Doc_Id;;
    this.SelectedParams.RejectionNotes = this.RejectionNotes;
    this.SelectedParams.taskId = this.taskId;
    this.dataService.Post(environment.eSignApiUrl + "/api/TakeAction/RejectDocument", this.SelectedParams)
      .subscribe(res => {
        this.RejectionNotes = "";
        setTimeout(() => {
          this.toastr.success("Document rejected successfully.");
          this.parentFun.emit(0);// 0 for workorder reject
        }, 4000)
      });

    this.RejectPopupOpen();
  }
  RejectPopupOpen() {
    debugger
    this.RejectionNotesError = false;
    //if (RejectFrom == 'RejectAndGoNext') { this.ISRejectAndGoNext = true } else { this.ISRejectAndGoNext = false }
    this.IsRejectPopupOpen = !this.IsRejectPopupOpen;
    if (this.IsRejectPopupOpen) { this.RejectPopupclass = "custom_modal notes_modal active" }
    else { this.RejectPopupclass = "custom_modal notes_modal" }
  }
}
